module.exports = __webpack_public_path__ + "img/pdf.0d56a880.png";